import { shape, bool, arrayOf, string, number } from 'prop-types';

const ProductPropType = shape({
  id: string,
  code: string,
  stock_value: number,
  price: number,
  name: string,
  title: string,
  inIquote: bool,
  description: string,
  pictures: arrayOf(shape({
    urlOverlayPicture: string,
    urlThumbnailPicture: string
  }))
});

export const ParsedProductPropType = shape({
  title: string,
  slug: string,
  vendor: string,
  id: string,
  name: string,
  inIquote: bool,
  code: string,
  sku: string,
  price: shape({
    currency: string,
    price: number,
    displayPrice: string,
    catalogPrice: number,
    displayCatalogPrice: string,
  }),
  quantity: number,
  isSoldOut: bool,
  // isBackorder: false,
  // isOnSale: false,
  isLowQuantity: bool,
  pictures: arrayOf(shape({
    urlOverlayPicture: string,
    urlThumbnailPicture: string
  })),
  primaryImage: shape({
    URLs: shape({
      large: string,
      medium: string,
      small: string,
      thumbnail: string
    })
  })
  // isBestseller: false
});

export default ProductPropType;
